/* eslint-disable */

const awsmobile = {
  aws_project_region: "ap-southeast-1",
  aws_cloud_logic_custom: [
    {
      name: "accounting",
      endpoint:
        "https://yfjdg9lkv7.execute-api.ap-southeast-1.amazonaws.com/Prod",
      region: "ap-southeast-1",
    },
    {
      name: "business",
      endpoint:
        "https://avuxbz6tij.execute-api.ap-southeast-1.amazonaws.com/Prod",
      region: "ap-southeast-1",
    },
    {
      name: "cashbook",
      endpoint:
        "https://5j1qanr6zc.execute-api.ap-southeast-1.amazonaws.com/Prod",
      region: "ap-southeast-1",
    },
    {
      name: "checkout",
      endpoint:
        "https://fptxyrpqz7.execute-api.ap-southeast-1.amazonaws.com/Prod",
      region: "ap-southeast-1",
    },
    {
      name: "consultant",
      endpoint:
        "https://56n7sncyog.execute-api.ap-southeast-1.amazonaws.com/Prod",
      region: "ap-southeast-1",
    },
    {
      name: "ebilling",
      endpoint:
        "https://x2recqdta4.execute-api.ap-southeast-1.amazonaws.com/Prod",
      region: "ap-southeast-1",
    },
    {
      name: "feedback",
      endpoint:
        "https://z0olkimlb0.execute-api.ap-southeast-1.amazonaws.com/Prod",
      region: "ap-southeast-1",
    },
    {
      name: "iap",
      endpoint:
        "https://7uhh5ogo98.execute-api.ap-southeast-1.amazonaws.com/Prod",
      region: "ap-southeast-1",
    },
    {
      name: "npwp",
      endpoint:
        "https://2a2fstc3i1.execute-api.ap-southeast-1.amazonaws.com/Prod",
      region: "ap-southeast-1",
    },
    {
      name: "user",
      endpoint:
        "https://gtwou09905.execute-api.ap-southeast-1.amazonaws.com/Prod",
      region: "ap-southeast-1",
    },
    {
      name: "emeterai",
      endpoint:
        "https://ahdsh4jgek.execute-api.ap-southeast-1.amazonaws.com/Prod",
      region: "ap-southeast-1",
    },
    {
      name: "point",
      endpoint:
        "https://qrkhng6dgi.execute-api.ap-southeast-1.amazonaws.com/Prod",
      region: "ap-southeast-1",
    },
    {
      name: "consultation",
      endpoint:
        "https://v2piwp31o3.execute-api.ap-southeast-1.amazonaws.com/Prod",
      region: "ap-southeast-1",
    },
    {
      name: "deleteUser",
      endpoint:
        "https://oy4q4pm46j.execute-api.ap-southeast-1.amazonaws.com/Prod",
      region: "ap-southeast-1",
    },
    {
      name: "marketing",
      endpoint:
        "https://72pwppackk.execute-api.ap-southeast-1.amazonaws.com/Prod",
      region: "ap-southeast-1",
    },
    {
      name: "referral",
      endpoint:
        "https://c7osfnybl5.execute-api.ap-southeast-1.amazonaws.com/Prod",
      region: "ap-southeast-1",
    },
    {
      name: "webinar",
      endpoint:
        "https://xtpinygxh5.execute-api.ap-southeast-1.amazonaws.com/Prod",
      region: "ap-southeast-1",
    },
  ],
  aws_appsync_graphqlEndpoint:
    "https://ypbunttvtfcx5e76dw5eexnnde.appsync-api.ap-southeast-1.amazonaws.com/graphql",
  aws_appsync_region: "ap-southeast-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_appsync_apiKey: "da2-ozpg3dig2baolbapdrwln5ekba",
  aws_cognito_identity_pool_id:
    "ap-southeast-1:0511af40-e2b6-4be0-8ee7-728b92eaa936",
  aws_cognito_region: "ap-southeast-1",
  aws_user_pools_id: "ap-southeast-1_VSqDifP0Z",
  aws_user_pools_web_client_id: "406tp8lh31nma7jlrjo7a7f4kr",
  oauth: {
    domain: "auth.pajakind.com",
    scope: [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin",
    ],
    redirectSignIn:
      "http://localhost:3000/verify/,https://web-user-v2-pajakind.vercel.app/verify/,https://web.pajakind.com/verify/",
    redirectSignOut:
      "http://localhost:3000/login/,https://web-user-v2-pajakind.vercel.app/login/,https://web.pajakind.com/login/",
    responseType: "code",
  },
  federationTarget: "COGNITO_IDENTITY_POOLS",
  aws_cognito_username_attributes: ["EMAIL", "PHONE_NUMBER"],
  aws_cognito_social_providers: ["Facebook", "Google", "SignInWithApple"],
  aws_cognito_signup_attributes: [],
  aws_cognito_mfa_configuration: "OPTIONAL",
  aws_cognito_mfa_types: ["SMS", "TOTP"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  aws_user_files_s3_bucket: "pajakind-images",
  aws_user_files_s3_bucket_region: "ap-southeast-1",
};

export default awsmobile;
